/* eslint-disable no-shadow */
/* eslint-disable radix */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
var ezdia;
(function (ezdia) {
    var currentReviewOrderObj = {};
    var orderKey;
    var pageParams;
    var loadOnce = true;
    var currentSelection;
    var serviceName;
    function selectAllRows(ids, clicked) {
        if (!pageParams.orderStatus) {
            var rowData = $('#grid').jqGrid('getRowData');
            if (clicked) {
                rowData.forEach(function (element) {
                    serviceName = element.order_type;
                    currentReviewOrderObj.addThisItem(serviceName, element);
                });
            }
            else {
                rowData.forEach(function (element) {
                    serviceName = element.order_type;
                    currentReviewOrderObj.removeThisItem(serviceName, element);
                });
            }
            currentReviewOrderObj.calculateTotalAmount();
        }
    }
    function onSelectRow(id, clicked) {
        var rowData = $(this).jqGrid('getRowData', id);
        serviceName = rowData.order_type;
        if (clicked) {
            currentReviewOrderObj.addThisItem(serviceName, rowData);
        }
        else {
            currentReviewOrderObj.removeThisItem(serviceName, rowData);
        }
        currentReviewOrderObj.calculateTotalAmount();
    }
    function renderSummary() {
        if (loadOnce) {
            $.ajax({
                url: "contentHealthOrderSummary.htm?key=" + orderKey,
                dataType: 'json',
                success: function (response) {
                    var template = $.ezdia.template.get('content-health-report-order-summary');
                    currentReviewOrderObj.orderDetails = response.order_details;
                    currentReviewOrderObj.total_amount = response.total_amount;
                    currentReviewOrderObj.discount = response.discount;
                    template = template(response);
                    $('#summaryContainer').html(template);
                    $('#cb_grid').click();
                    if (pageParams.orderStatus) {
                        $('#cb_grid').attr('disabled', 'disabled');
                    }
                    loadOnce = false;
                }
            });
        }
        else {
            populateSelecteditems();
        }
    }
    function populateSelecteditems() {
        if (!pageParams.orderStatus) {
            var rowData = $('#grid').jqGrid('getRowData');
            rowData.forEach(function forEach(element) {
                serviceName = element.order_type;
                var idArray = currentSelection.orderDetails[serviceName].ids.length
                    ? currentSelection.orderDetails[serviceName].ids.split(',')
                    : [];
                var index = idArray.indexOf(element.task_id);
                if (index > -1) {
                    currentReviewOrderObj.addThisItem(serviceName, element);
                    $('#grid')
                        .find("#" + element.id + " input[type=checkbox]")
                        .prop('checked', true);
                }
            });
        }
    }
    function showResponse(title, msg, pageReload) {
        var DIALOG_WRAPPER_ID = 'ez-review-order-wrapper';
        var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
        wrapper.html(msg).dialog({
            modal: true,
            title: title,
            width: 'auto',
            height: 'auto',
            buttons: [
                {
                    text: 'Ok',
                    class: 'btn-primary',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ],
            close: function () {
                if (pageReload) {
                    window.location.reload();
                }
            }
        });
    }
    var ContentHealthReviewOrderObj = /** @class */ (function () {
        function ContentHealthReviewOrderObj() {
            this.orderDetails = [];
            this.total_amount;
            this.discount;
        }
        ContentHealthReviewOrderObj.prototype.placeOrder = function (eventTarget) {
            if (this.total_amount) {
                $.ajax({
                    url: "createContentHealthOrder.htm?key=" + orderKey + "&order_details=" + JSON.stringify(this.orderDetails) + "&total_amount=" + this.total_amount + "&discount=" + this.discount + "&coupon=Category Manager Referral Discount",
                    dataType: 'json',
                    success: function (response) {
                        var title;
                        if (response.success) {
                            title = 'Order placed successfully!';
                            $(eventTarget).attr('disabled', 'disabled');
                        }
                        else {
                            title = 'Error occurred!';
                        }
                        showResponse(title, response.msg, true);
                    },
                    error: function () {
                        var title = 'Error occurred!';
                        showResponse(title, 'Something went wrong. Please try again!', false);
                    }
                });
            }
            else {
                var DIALOG_WRAPPER_ID = 'ez-review-order-wrapper';
                var wrapper = ezdia.util.getWrapper(DIALOG_WRAPPER_ID);
                var msg = 'Please select one item atleast to place the order.';
                wrapper.html(msg).dialog({
                    modal: true,
                    title: 'Select item/ items to continue',
                    width: 'auto',
                    height: 'auto',
                    buttons: [
                        {
                            text: 'Close',
                            class: 'btn-primary',
                            click: function () {
                                $(this).dialog('close');
                            }
                        }
                    ]
                });
            }
        };
        ContentHealthReviewOrderObj.prototype.calculateTotalAmount = function () {
            var currentTotal = 0;
            var currentDiscount = 0;
            var self = this;
            // tslint:disable-next-line: no-shadowed-variable
            Object.keys(this.orderDetails).forEach(function forEach(serviceName) {
                var totalAmount = self.orderDetails[serviceName].quantity *
                    self.orderDetails[serviceName].unit_price;
                $("#" + serviceName.replace(/\s/g, '') + " .total").text(totalAmount);
                self.orderDetails[serviceName].total_price = totalAmount;
                var discountAmount = (totalAmount * self.orderDetails[serviceName].discount) / 100;
                totalAmount -= discountAmount;
                currentDiscount += discountAmount;
                currentTotal += totalAmount;
                self.orderDetails[serviceName].discounted_price = discountAmount;
                $("#" + serviceName.replace(/\s/g, '') + " .quantity_count").text(self.orderDetails[serviceName].quantity);
            });
            $('#netPayable').text(currentTotal);
            $('#discountPrice').text(currentDiscount);
            $('#totalPrice').text(currentTotal + currentDiscount);
            self.total_amount = currentTotal;
            self.discount = currentDiscount;
        };
        // tslint:disable-next-line: no-shadowed-variable
        ContentHealthReviewOrderObj.prototype.removeThisItem = function (serviceName, rowData) {
            var idArray = currentReviewOrderObj.orderDetails[serviceName].ids.length
                ? currentReviewOrderObj.orderDetails[serviceName].ids.split(',')
                : [];
            var index = idArray.indexOf(rowData.task_id);
            if (index > -1) {
                idArray.splice(index, 1);
                // tslint:disable-next-line: radix
                parseInt(currentReviewOrderObj.orderDetails[serviceName].quantity) > 0
                    ? (currentReviewOrderObj.orderDetails[serviceName].quantity -= 1)
                    : '';
            }
            currentReviewOrderObj.orderDetails[serviceName].ids = idArray.join();
        };
        // tslint:disable-next-line: no-shadowed-variable
        ContentHealthReviewOrderObj.prototype.addThisItem = function (serviceName, rowData) {
            var idArray = currentReviewOrderObj.orderDetails[serviceName].ids.length
                ? currentReviewOrderObj.orderDetails[serviceName].ids.split(',')
                : [];
            var index = idArray.indexOf(rowData.task_id);
            if (index === -1) {
                idArray.push(rowData.task_id);
                if (
                // tslint:disable-next-line: radix
                parseInt(currentReviewOrderObj.orderDetails[serviceName].quantity)) {
                    currentReviewOrderObj.orderDetails[serviceName].quantity += 1;
                }
                else {
                    currentReviewOrderObj.orderDetails[serviceName].quantity = 1;
                }
            }
            currentReviewOrderObj.orderDetails[serviceName].ids = idArray.join();
        };
        ContentHealthReviewOrderObj.prototype.load = function (key, colModel, colNames) {
            pageLoadingDone();
            currentReviewOrderObj = this;
            orderKey = key;
            pageParams = $.ezdia.config.pageParams;
            $.ezdia.grid.create({
                id: 'grid',
                url: 'fetchContentHealthReviewData.htm',
                datatype: 'json',
                mtype: 'POST',
                loadonce: true,
                postData: {
                    key: key
                },
                caption: 'Review Order',
                colModel: colModel,
                colNames: colNames,
                rowNum: 10000,
                hidegrid: false,
                gridview: true,
                gridContainerId: 'gridContainer',
                pager: '#footer-grid',
                multiselect: !pageParams.orderStatus,
                viewrecords: true,
                columnChooser: true,
                onSelectAll: selectAllRows,
                onSelectRow: onSelectRow,
                gridComplete: renderSummary,
                beforeSelectRow: function () {
                    if (pageParams.orderStatus) {
                        return false; // not allow select the row
                    }
                    return true;
                },
                onSortCol: function () {
                    currentSelection = ezdia.util.jsonParse(JSON.stringify(currentReviewOrderObj));
                }
            });
        };
        return ContentHealthReviewOrderObj;
    }());
    var pages;
    (function (pages) {
        pages.contentHealthReviewOrder = new ContentHealthReviewOrderObj();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
